export default "__VITE_ASSET__eyVSS1_P__"